import Bar from "../Bar";
import Clock from "../Clock";
import Logo from "../Logo";
import Title from "../Title";
import classes from "../../styles/Bar.module.css";
import { getClasses } from "../../utils";
// import InfoLabel from "../InfoLabel";
// import Icons from "../Icons";

const TopBar: React.FC = () => {
  return (
    <Bar className={getClasses(classes, "semi-transparent", "portrait-top")}>
      <Logo />
      <Title />
      <Clock />
    </Bar>
  );
};

export default TopBar;
